import { render, staticRenderFns } from "./comp_UserOrderDetail-Payment.vue?vue&type=template&id=39c2f0c8"
import script from "./comp_UserOrderDetail-Payment.vue?vue&type=script&lang=js"
export * from "./comp_UserOrderDetail-Payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDivider,VIcon})
